<!-- 图片+标题 -->
<template>
  <div
    class="sceneApply"
    :style="{backgroundImage: 'url(' + (bgimage ? bgimage : '') + ')', backgroundSize:'contain'}"
  >
    <h3 class="h3" :class="bgimage?'write':''">{{title}}</h3>
    <div class="sceneApplyImg width">
      <img :src="image" alt srcset :class="wwidth?'wwidth':''" />
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  props: { title: String, image: String, bgimage: String, wwidth: String },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
}
</script>

<style lang="less" scoped>
.sceneApply {
  background-color: #fff;
  padding-top: 20px;
  margin-bottom: 10px;
  padding-bottom: 20px;
  .h3 {
    width: 140px;
    height: 25px;
    font-weight: 700;
    font-style: normal;
    font-size: 20px;
    text-align: center;
    padding-bottom: 10px;
    border-bottom: 2px solid #0078d7;
    margin: 0 auto 20px auto;
  }
  .write {
    color: #fff;
  }
  .sceneApplyImg {
    text-align: center;
    img {
      width: 900px;
    }
    .wwidth {
      width: 100%;
    }
  }
}
</style>
